import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	legendLabel: {
		id: 'software-deployments.timeline.legend.legend-label',
		defaultMessage: 'Key',
		description: 'Label for the legend keys',
	},
	nonProduction: {
		id: 'software-deployments.timeline.legend.non-production',
		defaultMessage: 'Non-production deployment',
		description: 'Legend key for non-production deployments',
	},
	production: {
		id: 'software-deployments.timeline.legend.production',
		defaultMessage: 'Production deployment',
		description: 'Legend key for production deployments',
	},
	failed: {
		id: 'software-deployments.timeline.legend.failed',
		defaultMessage: 'Failed deployment',
		description: 'Legend key for Failed deployments',
	},
	cancelled: {
		id: 'software-deployments.timeline.legend.cancelled',
		defaultMessage: 'Canceled deployment',
		description: 'Legend key for cancelled deployments',
	},
	inProgress: {
		id: 'software-deployments.timeline.legend.in-progress',
		defaultMessage: 'In-progress deployment ',
		description: 'Legend key for in progress deployments',
	},
	pending: {
		id: 'software-deployments.timeline.legend.pending',
		defaultMessage: 'Pending deployment',
		description: 'Legend key for a pending deployment',
	},
	rolledBack: {
		id: 'software-deployments.timeline.legend.rolled-back',
		defaultMessage: 'Rolled back deployment',
		description: 'Legend key for a rolled back deployment',
	},
	showMore: {
		id: 'software-deployments.timeline.legend.show-more',
		defaultMessage: 'Show more',
		description: 'A label that when clicked will expland the key to show more deployment states',
	},
	showLess: {
		id: 'software-deployments.timeline.legend.show-less',
		defaultMessage: 'Show less',
		description: 'A label that when clicked will minimise the key to show less deployment states',
	},
});
